import { v4 as uuid } from 'uuid'
import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnReorder(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  return async function onReorder(data) {
    change(data)
  }
}

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  let stages = useDataValue({
    context: 'selected',
    path: 'stages',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let newStages = [...stages]
    // insert the new stage before done
    newStages.splice(newStages.length - 1, 0, {
      text: '',
      order: stages.length,
      id: uuid(),
      autofocus: true,
      done: false,
    })

    // bump the order of done - always last
    newStages = newStages.map(stage =>
      stage.text === 'Done' ? { ...stage, order: stage.order + 1 } : stage
    )

    change(newStages)
  }
}
